import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2.25, 0),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(3, 0),
  },
  '& .DTSTitleContainer':{
    marginTop: theme.spacing(1.5),
  },
}));
export default StyledBox;